module.exports = __webpack_public_path__ + "img/Jack.f99bb389.jpg";